/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import kebabCase from 'lodash/kebabCase'

import useStorefronts from 'lib/network/hooks/useStorefronts'
import useGeolocation from 'lib/network/hooks/useGeolocation'
import { getQueryValue } from 'lib/helpers/queryValues'

import Layout from 'components/Layout'
import Stores from 'components/stores'
import Meta from './Meta'

const IndividualStorePage = ({ store }) => {
  const [metadata, setMetadata] = useState({})
  const [storeToShow, setStoreToShow] = useState(null)

  const router = useRouter()
  const { query } = router
  const permalink = getQueryValue(query.permalink)

  const { data: geolocation } = useGeolocation()
  const { latLong: visitorLatLong } = geolocation || {}
  const { data: sortedStorefronts, isValidating: isLoading } = useStorefronts(visitorLatLong)
  const selectedStore =
    store || sortedStorefronts?.find(item => kebabCase(item.displayName) === permalink) || null

  useEffect(() => {
    if (selectedStore?.name && !isLoading) {
      setMetadata({
        title: selectedStore.name,
        description: `Address:
          ${selectedStore.streetAddress};
          ${selectedStore.city},
          ${selectedStore.regionCode} ${selectedStore.postalCode}.
          Hours: ${selectedStore.hours}`,
        url: `/stores/${permalink}`,
        image: selectedStore.images[0].path,
      })

      setStoreToShow(permalink)
    }
  }, [
    selectedStore?.name,
    selectedStore?.streetAddress,
    selectedStore?.city,
    selectedStore?.regionCode,
    selectedStore?.postalCode,
    selectedStore?.hours,
    selectedStore?.images,
    isLoading,
    permalink,
  ])

  return (
    <Layout>
      <Meta {...metadata} />
      <Stores
        stores={sortedStorefronts}
        storeToShow={storeToShow}
        setStoreToShow={setStoreToShow}
        isLoading={isLoading}
      />
    </Layout>
  )
}

export default IndividualStorePage
